import { authHeader, handleResponse } from '../helpers';
export const DamageRptService = {
    fetchDamageData   
};

function fetchDamageData(data) {
    //console.log(data);
    ;
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };
    return fetch(`${process.env.REACT_APP_API_URL}Damage/GetDamages`, requestOptions)
        .then(handleResponse);
}

